import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import styles from './styles.module.css'
import { TireSizeButton } from './TireSizeButton'
import CustomTireSize from '../custom-size/CustomTireSize'
import CircularProgress from '@mui/material/CircularProgress'
import CustomSizeButton from './CustomSizeButton'
import useFetch from '../../../../../../global/hooks/useFetchHook'
import { getTireSize } from '../api'
import { IScheduleModalComponentProps } from '../../container-modal/ScheduleModal'
import { ITiresCombination } from '../../../../../../../../app/entities/TiresCombination'
import { DeepPartial } from 'typeorm'

interface ISelectTireSizeProps {
  selectedTiresCombination: DeepPartial<ITiresCombination>
  setSelectedTiresCombination: Dispatch<
    SetStateAction<DeepPartial<ITiresCombination>>
  >
  schedulerProps: IScheduleModalComponentProps
  mode?: string
}

function areTiresCombinationsSame(
  tiresCombination1: DeepPartial<ITiresCombination>,
  tiresCombination2: DeepPartial<ITiresCombination>,
) {
  //prettier-ignore
  return (
    tiresCombination1.frontTire?.width === tiresCombination2.frontTire?.width &&
    tiresCombination1.rearTire?.width === tiresCombination2.rearTire?.width &&
    Number(tiresCombination1.frontTire?.aspectRatio) === Number(tiresCombination2.frontTire?.aspectRatio) &&
    Number(tiresCombination1.rearTire?.aspectRatio) === Number(tiresCombination2.rearTire?.aspectRatio) &&
    Number(tiresCombination1.frontTire?.diameter) === Number(tiresCombination2.frontTire?.diameter) &&
    Number(tiresCombination1.rearTire?.diameter) === Number(tiresCombination2.rearTire?.diameter)
  )
}

function formatTireSize(item: ITiresCombination, index: any) {
  const { frontTire, rearTire } = item

  return {
    inches: `${frontTire?.diameter}"`,
    frontSize: `${frontTire?.width} : ${frontTire?.aspectRatio} R${frontTire?.diameter}`,
    rearSize: `${rearTire?.width} : ${rearTire?.aspectRatio} R${rearTire?.diameter}`,
    id: index,
    item: item,
  }
}

export function SelectTireSize(props: ISelectTireSizeProps) {
  const {
    selectedTiresCombination,
    setSelectedTiresCombination,
    schedulerProps,
  } = props

  const { schedulerState } = schedulerProps
  const { customerInformation, tiresCombination } = schedulerState

  const [selectedIndex, setSelectedIndex] = useState(0)

  const tireInfo = JSON.stringify({
    brand: { name: customerInformation.brandName },
    year: customerInformation.year,
    model: customerInformation.model,
    variant: customerInformation.variant,
  })
  const {
    data: newTiresCombinations,
    isLoading,
    refetch,
    error,
  } = useFetch<ITiresCombination[]>(getTireSize(tireInfo))

  useEffect(() => {
    const newTiresCombination =
      newTiresCombinations && newTiresCombinations.length > 0
    const existingWidthExists =
      tiresCombination.frontTire?.width || tiresCombination.rearTire?.width
    if (newTiresCombination && !existingWidthExists) {
      const newTiresCombination = newTiresCombinations[0]
      setSelectedTiresCombination(newTiresCombination)
    } else if (newTiresCombination && existingWidthExists) {
      const index = newTiresCombinations.findIndex((newTiresCombination) =>
        areTiresCombinationsSame(newTiresCombination, tiresCombination),
      )
      setSelectedIndex(index)
    }
  }, [newTiresCombinations])

  return (
    <div className={styles.selectTireSizeContainer}>
      <div className={`${styles.selectTireSizeTitle} font--bold`}>
        Select Tire Size
      </div>
      {isLoading || error ? (
        <CircularProgress />
      ) : (
        <>
          <div className={styles.tireSizeButtonContainer}>
            {newTiresCombinations &&
              newTiresCombinations.map(
                (item: ITiresCombination, index: any) => {
                  if (!item.frontTire || !item.rearTire) {
                    return null
                  }

                  const formatted = formatTireSize(item, index)
                  return (
                    <TireSizeButton
                      {...formatted}
                      item={item}
                      selected={selectedIndex}
                      setSelectedItem={setSelectedTiresCombination}
                      onClick={setSelectedIndex}
                      key={index}
                    />
                  )
                },
              )}
            <CustomSizeButton
              selected={selectedIndex}
              id={-1}
              onClick={setSelectedIndex}
              setSelectedItem={setSelectedTiresCombination}
            />
          </div>
          {selectedIndex === -1 && (
            <CustomTireSize
              selectedItem={selectedTiresCombination}
              setSelectedItem={setSelectedTiresCombination}
            />
          )}
        </>
      )}
    </div>
  )
}
